<ng-container *ngFor="let field of fields">
   <span *ngIf="field.controlType === 'buildStatus'" class="p-grid p-text-center">     
      <div
        *ngIf="entity[field.key] && entity[field.key].buildStatus"
        class="p-col p-mx-2 p-mt-3"
        [ngStyle]="{
          position: 'relative',
          color: 'var(--primary-color-text)',
          'background-color': entity[field.key]?.buildStatus.color || '',
          'border-radius': '0.5em'
        }"
      >
        <ng-container [ngSwitch]="entity[field.key].buildStatus.text">
          <ng-container *ngSwitchCase="'n/a'">
            <h3 class="p-m-0 p-text-center">Not Found</h3>
          </ng-container>
  
          <ng-container *ngSwitchDefault>
            <h3 class="p-d-inline p-m-0 p-text-center">
              {{ entity[field.key].buildStatus.text }}
            </h3>
            <p class="p-d-inline">
              {{ entity[field.key].buildStatus.date }}
            </p>
  
            <p-badge
              [value]="entity[field.key].buildStatus.buildCount"
              [style]="{
                'background-color': entity[field.key]?.buildStatus.color || '',
                position: 'absolute',
                right: '20%',
                top: '-1em'
              }"
            ></p-badge>
          </ng-container>
        </ng-container>
      </div>
    </span>
  </ng-container>  